import React, { useState } from "react";
import styles from "./UpsertAccountModal.module.scss";
import { BaseModal } from "@whatslly/ui-components/modals/BaseModal";
import { IModalInstance, ModalHeader } from "@whatslly/ui-components/modals";
import { TextInput } from "@whatslly/ui-components/v2/BaseElements/TextInput";
import { useTranslation } from "react-i18next";
import { ModalButtons } from "@whatslly/ui-components/ModalButtons";

type ChangeAccountNameModalProps = IModalInstance<string> & {
  accountName: string;
};

export const ChangeAccountNameModal: React.FC<ChangeAccountNameModalProps> = ({ closeModal, accountName }) => {
  const [newAccountName, setNewAccountName] = useState(accountName);
  const { t } = useTranslation();
  return (
    <BaseModal
      header={<ModalHeader closeModal={closeModal}>{t("search_accounts.change_account_name")}</ModalHeader>}
      closeOnClickOutside={false}
      closeOnEscape={true}
      closeModal={closeModal}
      className={styles.modal}
      bodyClassName={styles.body}
    >
      <TextInput
        placeholder={t("account_admin.overview_page.account_name")}
        defaultValue={accountName}
        onChange={(e) => setNewAccountName(e.target.value)}
        data-testid="account-name"
      />
      <ModalButtons
        isSubmitDisabled={accountName === newAccountName || newAccountName === ""}
        testId="modal-buttons-submit-button"
        onCancel={closeModal}
        onSubmit={() => closeModal(newAccountName)}
      />
    </BaseModal>
  );
};
